import {
  ADMINISTRATION_PROJECT_DESCRIPTION,
  projectDescriptionUrl,
} from 'SharedDir/backend/endpoints/administration-project-description';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import {
  ProjectDescription,
  ProjectDescriptionUpdate,
} from 'SharedDir/declarations/project-description';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';

export default class ProjectDescriptionApiClass extends SimpleApi<
  ProjectDescription,
  ProjectDescriptionUpdate
> {
  constructor() {
    super(projectDescriptionUrl);
  }

  // eslint-disable-next-line class-methods-use-this
  async getAll<T extends { tag?: string }>(params?: T) {
    const { data } = (await http({
      ...ADMINISTRATION_PROJECT_DESCRIPTION.GET,
      params,
    })) as AxiosResponse<ProjectDescription[]>;
    return data;
  }
}
